import { render } from "./GameView.vue?vue&type=template&id=984d7b20"
import script from "./GameView.vue?vue&type=script&lang=js"
export * from "./GameView.vue?vue&type=script&lang=js"

import "./GameView.vue?vue&type=style&index=0&id=984d7b20&lang=css"

import exportComponent from "/Users/peterdevos/Apps/sdworks_reaction_game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__